import { UserRoleDto } from './../../_models/userRole.models';
import { AuthorizedUserInfoDto, UserDetailDto, UserDto, PlantDto } from './../../_models';
import { userService } from "../../_services"
import { USER_ACTION_TYPES, COMMON_ACTION_TYPES, APP_MESSAGES } from "../../_constants";
import {
    AssignUserFactoriesPayloadStructure,
    AssignUserRolePayloadStructure,
    CreateUserPayloadStructure,
    UserListFiltersStructure
} from "../../_models/app.models";
import { exceptionHandler } from "../../_helpers";

const authorizeUser = (userEmail: string, onSuccess?: (d: UserDetailDto) => void, onError?: (e: string) => void) => {
    return action => {
        action({ type: USER_ACTION_TYPES.GET_USER_DETAIL + COMMON_ACTION_TYPES.REQUEST })
        userService.getUserDetail(userEmail, true)
            .then(res => {
                action({ type: USER_ACTION_TYPES.GET_USER_DETAIL + COMMON_ACTION_TYPES.SUCCESS, data: res.data })
                onSuccess && onSuccess(res.data)
            })
            .catch(error => {
                action({ type: USER_ACTION_TYPES.GET_USER_DETAIL + COMMON_ACTION_TYPES.ERROR })
                onError && onError(exceptionHandler.catchError(error.response))
            })
    }
}

const getUserDetail = (userEmail: string, onSuccess?: (d: UserDetailDto) => void, onError?: (e: string) => void) => {
    return action => {
        action({ type: USER_ACTION_TYPES.GET_USER_DETAIL + COMMON_ACTION_TYPES.REQUEST })
        userService.getUserDetail(userEmail)
            .then(res => {
                action({ type: USER_ACTION_TYPES.GET_USER_DETAIL + COMMON_ACTION_TYPES.SUCCESS, data: res.data })
                onSuccess && onSuccess(res.data)
            })
            .catch(error => {
                action({ type: USER_ACTION_TYPES.GET_USER_DETAIL + COMMON_ACTION_TYPES.ERROR })
                onError && onError(exceptionHandler.catchError(error.response))
            })
    }
}

const getUserList = (filters: UserListFiltersStructure, onSuccess?: (d: UserDto[]) => void, onError?: (e: string) => void) => {
    return action => {
        action({ type: USER_ACTION_TYPES.GET_USER_LIST + COMMON_ACTION_TYPES.REQUEST })
        userService.getUserList(filters)
            .then(res => {
                action({ type: USER_ACTION_TYPES.GET_USER_LIST + COMMON_ACTION_TYPES.SUCCESS, data: res.data })
                onSuccess && onSuccess(res.data)
            })
            .catch(error => {
                action({ type: USER_ACTION_TYPES.GET_USER_LIST + COMMON_ACTION_TYPES.ERROR })
                onError && onError(exceptionHandler.catchError(error.response))
            })
    }
}

const getUserRoleList = (userEmail: string, onSuccess?: (d: UserRoleDto[]) => void, onError?: (e: string) => void) => {
    return action => {
        action({ type: USER_ACTION_TYPES.GET_USER_ROLE_LIST + COMMON_ACTION_TYPES.REQUEST })
        userService.getUserRoleList(userEmail)
            .then(res => {
                action({ type: USER_ACTION_TYPES.GET_USER_ROLE_LIST + COMMON_ACTION_TYPES.SUCCESS, data: res.data })
                onSuccess && onSuccess(res.data)
            })
            .catch(error => {
                action({ type: USER_ACTION_TYPES.GET_USER_ROLE_LIST + COMMON_ACTION_TYPES.ERROR })
                onError && onError(exceptionHandler.catchError(error.response))
            })
    }
}

const createUser = (payload: CreateUserPayloadStructure, onSuccess, onError) => {
    return action => {
        action({ type: USER_ACTION_TYPES.CREATE_USER + COMMON_ACTION_TYPES.REQUEST })
        userService.createUser(payload)
            .then(
                (res) => {
                    let responseMessage;
                    if (res.status === 200) {
                        responseMessage = APP_MESSAGES.USER_UPDATE_SUCCESS;
                    }
                    if (res.status === 201) {
                        responseMessage = APP_MESSAGES.USER_CREATE_SUCCESS;
                    }
                    action({ type: USER_ACTION_TYPES.CREATE_USER + COMMON_ACTION_TYPES.SUCCESS, data: res.data })
                    onSuccess(res.data, responseMessage)
                },
            )
            .catch(
                (error) => {
                    action({ type: USER_ACTION_TYPES.CREATE_USER + COMMON_ACTION_TYPES.ERROR })
                    onError(exceptionHandler.catchError(error.response))
                }
            )

    }
}

const assignUserRole = (payload: AssignUserRolePayloadStructure, onSuccess, onError) => {
    return action => {
        action({ type: USER_ACTION_TYPES.ASSIGN_USER_ROLES + COMMON_ACTION_TYPES.REQUEST })
        userService.assignUserRole(payload)
            .then(
                (res) => {
                    action({ type: USER_ACTION_TYPES.ASSIGN_USER_ROLES + COMMON_ACTION_TYPES.SUCCESS, data: res.data })
                    onSuccess(res.data, APP_MESSAGES.USER_ROLE_UPDATE_SUCCESS)
                },
            )
            .catch(
                (error) => {
                    action({ type: USER_ACTION_TYPES.ASSIGN_USER_ROLES + COMMON_ACTION_TYPES.ERROR })
                    onError(exceptionHandler.catchError(error.response))
                }
            )
    }
}

const assignUserFactories = (payload: AssignUserFactoriesPayloadStructure, onSuccess, onError) => {
    return action => {
        action({ type: USER_ACTION_TYPES.ASSIGN_USER_FACTORIES + COMMON_ACTION_TYPES.REQUEST })
        userService.assignUserFactories(payload)
            .then(
                (res) => {
                    action({ type: USER_ACTION_TYPES.ASSIGN_USER_FACTORIES + COMMON_ACTION_TYPES.SUCCESS, data: res.data })
                    onSuccess(res.data, APP_MESSAGES.USER_FACTORY_UPDATE_SUCCESS)
                },
            )
            .catch(
                (error) => {
                    action({ type: USER_ACTION_TYPES.ASSIGN_USER_FACTORIES + COMMON_ACTION_TYPES.ERROR })
                    onError(exceptionHandler.catchError(error.response))
                }
            )
    }
}

export const userActions = {
    authorizeUser,
    getUserDetail,
    getUserList,
    getUserRoleList,
    createUser,
    assignUserRole,
    assignUserFactories
};
